import { NgModule } from '@angular/core';
import { RouterModule, Routes }from '@angular/router';
import { AssignmentFullComponent } from './assignment/assignment-full/assignment-full.component';
import { AppComponent } from './app.component';
import { AssignmentQuickStartComponent } from './quick-start/assignment-quick-start/assignment-quick-start.component';
import { AssignmentGradingComponent } from './assignment/assignment-grading/assignment-grading.component';
import { SubmissionViewComponent } from './assignment/submission-view/submission-view.component';
import { ViewerComponent } from './embedded-view/viewer/viewer.component';

const routes: Routes = [
    {path:':entityType/:entityId/:contentType/viewer', component : ViewerComponent},
    {path:'assignments/:aid/submissions', component : AssignmentGradingComponent},
    {path:'assignments/:aid/submissions/:sid', component : AssignmentGradingComponent},
    {path:'assignments/:id', component : AssignmentFullComponent},
    {path:'quickStart/assignment', component : AssignmentQuickStartComponent}
]
//{ path: '**', component:  }

@NgModule({
    imports: [
        RouterModule.forRoot(routes, {}) //, {enableTracing : true})
    ],
    providers: [],
    declarations: [
        AppComponent
    ]
})
export class AppRoutingModule { }